import React from 'react'
import PropTypes from 'prop-types'
import Currency from 'components/Currency'

const OrderTypeCart = ({ order, seller }) => (
  <div className="multiple flex flex-col">
    <h2 className="mt-0">
      {order.type === 'cart' ? 'Carrinho' : 'Detalhes da Transação'}
    </h2>
    <p className="m-0 text-xl">{seller.name}</p>
    <div className="multiple__content">
      <table className="sidebar-table">
        <tbody>
          {order.products.map((product, index) => (
            <tr key={index}>
              <td style={{ wordBreak: 'break-all' }}>{product.description}</td>
              <td>
                <h4 className="m-0 text-lg text-gray-600">
                  <Currency value={product.total_price} />
                </h4>
                <p className="m-0 text-xs" style={{ whiteSpace: 'nowrap' }}>
                  {product.quantity} uni.{' '}
                  <Currency value={product.unit_price} />
                </p>
              </td>
            </tr>
          ))}
          {order.shipping_price ? (
            <tr className="sidebar-table__shipping">
              <td>Frete ({order.shipping_type})</td>
              <td>
                <h4 className="m-0 text-lg text-gray-600">
                  <Currency value={order.shipping_price} />
                </h4>
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
    <h2 className="m-0 py-4 text-right sidebar-total">
      Total:{' '}
      <strong>
        <Currency value={order.total_price} />
      </strong>
    </h2>
  </div>
)

OrderTypeCart.propTypes = {
  order: PropTypes.object.isRequired,
  seller: PropTypes.object.isRequired,
}

export default OrderTypeCart
